import { Validators } from '@angular/forms';
import _ from 'lodash';
import { InPersonEventSchema } from './in-person-event';
import { VirtualEventSchema } from './virtual-event';

export const HybridEventSchema = {
    fields: [{
        'field': 'id',
        'value': null,
        'validators': []
    }, {
      'field': 'imageFile',
      'value': null,
      'validators': [],
      'options': {
        'virtual': true
      }
    }, {
      'field': 'imageUrl',
      'value': '/images/blank_2x1.png',
      'validators': [],
      'options': {
        'getter': (control) => {
          return control.value === '/images/blank_2x1.png' ? '' : control.value
        },
        'setter': (data, value) => {
          return value === '' ? '/images/blank_2x1.png' : value
        }
      }
    }, {
      'field': 'imageDataUrl',
      'value': '/images/blank_2x1.png',
      'validators': [],
      'options': {
        'virtual': true,
        'getter': (control) => {
          return control.value === '/images/blank_2x1.png' ? '' : control.value
        },
        'setter': (data, value) => {
          return data.imageUrl === '' ? '/images/blank_2x1.png' : data.imageUrl
        }
      }
    },
    {
        'field': 'name',
        'value': '',
        'validators': [Validators.required, Validators.maxLength(128)]
    }, {
        'field': 'desc',
        'value': '',
        'validators': []
    }],
    groups: [
        { ...InPersonEventSchema, group: 'inPersonEvent' },
        { ...VirtualEventSchema, group: 'virtualEvent' }
    ]
}
